<template>
    <div class="app">
        <el-container>
            <el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

            
                <div class="main-div">
                    <el-container class="main-div parentDiv">
                        <!-- 2021/11/19  #12251  START -->
                        <div class="SID0008_DilaogDiv" v-loading.fullscreen.lock="fullscreenLoading">
                            <section>
                                <el-dialog title=""
                                    :visible.sync="dialogVisible"
                                    close="false"
                                    :close-on-click-modal="false"
                                    class="SID0009_DilaogDiv PrintHideArea">
                                <el-container>
                                    <div class="SID0009__popupScreen3">
                                        <div class="FirstSpan3">
                                            <span>要求された記事は表示できません。</span>
                                        </div>  
                                        <div class="ButtonClose3">
                                            <el-button type="info" plain @click="closeTab">閉じる</el-button>
                                        </div>
                                    </div>
                                </el-container>
                                </el-dialog>
                            </section>
                        </div>
                        <!-- 2021/11/19  #12251  END -->
                        <splitpanes class="default-theme defaultStyle custom-splite">
                            <pane size="100" class="SideBarLeft">
                                <div class="SID004Copy">
                                    <!-- Breadcrumb section -->
                                    <section> 
                                        <div class="requiredArticleTitle">
                                            <span>{{AlertMessage}}</span>
                                        </div>
                                    </section>
                                    <!-- Tad section -->
                                    <section v-if="articleListDisplayFlag">
                                        <div class="listOrderArticle">
                                            <span v-if="originalTextDisplayFlag">原文表示不可記事一覧</span>
                                            <span v-if="printTextDisplayFlag">原文印刷不可記事一覧</span>
                                        </div>
                                        <div>
                                            <el-tabs v-model="activeName">
                                                <el-tab-pane  v-bind:label="CounterLabel" name="first">
                                                    <div id="aricleNews">
                                                        <NewsArticle0004 />
                                                    </div>
                                                </el-tab-pane>
                                            </el-tabs>
                                        </div>
                                    </section>
                                    <!-- Bottom section -->
                                    <section>
                                        <div class="bottomTextSpan">
                                            <span v-if="displayButton">原文表示可能な記事で表示する場合には、表示ボタンを押してください。</span>
                                            <span v-if="printButton">原文印刷可能な記事で印刷する場合には、印刷ボタンを押してください。</span>
                                            <span>もう一度記事選択に戻る場合には、閉じるボタンを押してください。</span>
                                        </div>
                                        <el-row class="newsArticleButtonBottom">
                                            <el-button type="primary" @click="goToPdfScreen" v-loading.fullscreen.lock="fullscreenLoading" v-if="displayButton" plain>表示</el-button>
                                            <el-button type="primary" @click="goToPrintScreen" v-loading.fullscreen.lock="fullscreenLoading" v-if="printButton" plain>印刷</el-button>
                                            <el-button type="info" @click="closeTab" plain>閉じる</el-button>
                                        </el-row>
                                    </section>
                                </div>
                                <!-- </el-dialog> -->
                            </pane>
                            <pane class="SideBarRight">
                                <SideBar class="SidePane" />
                            </pane>
                        </splitpanes>
                    </el-container></div>
            <el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
        </el-container>
    </div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import NewsArticle0004 from "../top_page/newsArticle0004.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import router from "../../router";
 import Vue from "vue";
export default {
    name: "RequiredArticle",
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
        Pane,
        NewsArticle0004,
    },
    data() {
		return {
            activeName: 'first',
            dialogTableVisible0004:true,
            displayButton: Vue.prototype.$session.get('displayButton'),
            printButton: Vue.prototype.$session.get('printButton'),
            CounterLabel: Vue.prototype.$session.get('CounterLabel'),
            AlertMessage: Vue.prototype.$session.get('AlertMessage'),
            articleListDisplayFlag: Vue.prototype.$session.get('articleListDisplayFlag'),
            userId: '',
            contract_code: '',
            theme_browsing: '',
            fullscreenLoading: false,
            // 2021/11/19  #12251  START
            dialogVisible: false,
            // 2021/11/19  #12251  END
            originalTextDisplayFlag: Vue.prototype.$session.get('originalTextDisplayFlag'),
            printTextDisplayFlag: Vue.prototype.$session.get('printTextDisplayFlag')
		};
	},
    methods:{
        closeTab(){
            this.$LogButtonEvent("0004","close");
			this.$LogMethodIN("0004","closeTab");
            var mailFlag = Vue.prototype.$session.get('mailFlagForCloseButton')
            if(mailFlag)
            {
                router.push('/0002');
            }
            else
            {
                window.close();
            }
            this.$LogMethodOut("0004","closeTab");
        },
        goToPdfScreen(){
            this.$LogButtonEvent("0004","pdf");
			this.$LogMethodIN("0004","goToPdfScreen");
            var pdfConvertValues = Vue.prototype.$session.get('pdfConvertValues');
            var pdfCompletionArray = Vue.prototype.$session.get('pdfSuccessArray')
            var pdfValues = {
                pdf_flag:1,
                article_info:pdfConvertValues,
                user_id:this.userId,
                contract_code:this.contract_code,
                theme_browsing:this.theme_browsing,
                display_id:"SID0002",
                // 2022/08/03  #13204  START
                is_from0004:true,
                // 2022/08/03  #13204  END
                is_mail:false
            };

            var pdfSuccessArray = {
                data_info: pdfCompletionArray
            }

            var pdfCombinedArray = [];

            pdfCombinedArray = [...pdfCombinedArray, pdfValues, pdfSuccessArray];
            /*******BT08460_EXTERNAL-1539 issue fix*******/
            this.$session.set('pdfCombinedArray', pdfCombinedArray);
            let routeData = this.$router.resolve({name: '0001-001', params: pdfCombinedArray}); 
            window.open(routeData.href, '_blank');
            /*this.fullscreenLoading = true;
            this.$store.dispatch('communication0004/getPdfDisplay', pdfCombinedArray).then(() => {
                this.fullscreenLoading = false;
            }).catch(() => {
                this.fullscreenLoading = false;
            })*/
            /*******BT08460_EXTERNAL-1539 issue fix*******/
            this.$LogMethodOut("0004","goToPdfScreen");
            
           
        },
        goToPrintScreen(){
            this.$LogButtonEvent("0004","pdf");
			this.$LogMethodIN("0004","goToPrintScreen");
            var printValues = Vue.prototype.$session.get('printConvertValues');
            var printCompletionArray = Vue.prototype.$session.get('printSuccessArray')
            var pdfValues = {
                pdf_flag:2,
                article_info:printValues,
                user_id:this.userId,
                contract_code:this.contract_code,
                theme_browsing:this.theme_browsing,
                // 2022/08/03  #13204  START
                is_from0004:true,
                // 2022/08/03  #13204  END
                display_id:"SID0002"
            };

            var printSuccessArray = {
                data_info: printCompletionArray
            }

            var printCombinedArray = [];

            printCombinedArray = [...printCombinedArray, pdfValues, printSuccessArray];
            
            this.fullscreenLoading = true;
            this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
                this.fullscreenLoading = false;
            })
            this.$LogMethodOut("0004","goToPrintScreen");
        }
    },
    mounted() {
        //get the user id value from session
        this.userId = this.getUserId

        //get the contract code value from session
        this.contract_code = this.getContractCode
        
        // 2021/11/19  #12251  START
        if(this.getDialogFlag){
            this.dialogVisible=true;
        }
        // 2021/11/19  #12251  END

        //get the theme_browsing value from session
        this.theme_browsing = this.getThemeBrowsing
        if (this.getDemandMaxCountAlert !='') {
            this.$alert(this.getDemandMaxCountAlert, "確認", {
                confirmButtonText: "OK",
            });
        }
        else{
            //No action
        }
    },
    created(){
    //For the screen Title
     document.title = "記事閲覧";
  },
  beforeCreate(){
        //Common.Session.CheckSessionExists_IfExpired_GoToLogout();
        //Common.Session.CheckIsMobile("/sp/0004","/0004"); // MobileScreen Path, WebScreen Path
    },
    computed: {
        ...mapGetters("situation0004", [
            "getContractCode0020",
            "getUserId0020",
            "getcheck",
            "getNewsArticles",
            "getCounterLabel",
            "getname",
            "getPdfName",
            // 2021/11/19  #12251  START
            "getDialogFlag",
            // 2021/11/19  #12251  END
            "getredisplayPdfInput",
            "getDemandMaxCountAlert"
        ]),
        ...mapGetters("situation0001", [
            "getUserId",
            "getContractCode",
            "getThemeBrowsing"

        ]),
        ...mapGetters("situation",["getPopUpBlockerFlag"]),
	}
}
</script>

<style scoped>
@import "0004.css";
@import "../0009/0009.css";
</style>